import axios from "axios";

const endpoint = process.env.REACT_APP_API_URL;

export const FETCH_MARKERS_BEGIN = "FETCH_MARKERS_BEGIN";
export const FETCH_MARKERS_SUCCESS = "FETCH_MARKERS_SUCCESS";
export const FETCH_MARKERS_FAILURE = "FETCH_MARKERS_FAILURE";
export const UPDATE_MARKER = "UPDATE_MARKER";
export const SET_SELECTED_MARKER = "SET_SELECTED_MARKER";
export const CLEAR_SELECTED_MARKER = "CLEAR_SELECTED_MARKER";

export const fetchMarkersBegin = () => ({
  type: FETCH_MARKERS_BEGIN,
});

export const fetchMarkersSuccess = (company) => ({
  type: FETCH_MARKERS_SUCCESS,
  payload: company,
});

export const fetchMarkersFailure = (error) => ({
  type: FETCH_MARKERS_FAILURE,
  payload: { error },
});

export const updateMarker = (data) => ({
  type: UPDATE_MARKER,
  payload: data,
});

export const setSelectedMarker = (marker) => ({
  type: SET_SELECTED_MARKER,
  payload: marker,
});

export const clearSelectedMarker = () => ({
  type: CLEAR_SELECTED_MARKER,
});

export function updateSelectedMarker(marker) {
  return (dispatch) => {
    dispatch(setSelectedMarker(marker));
  };
}

export function searchMarker(searchTerm) {
  return (dispatch) => {
    dispatch();
  };
}

export async function getMarkers() {
  return async (dispatch) => {
    dispatch(fetchMarkersBegin());
    try {
      const { data } = await axios.get(`${endpoint}/markers`);
      dispatch(fetchMarkersSuccess(data));
    } catch (err) {
      dispatch(fetchMarkersFailure(err));
    }
  };
}
